import { useRef, type ReactElement } from "react";
import { useWholeWidth } from "./measure.ts";
import { logical } from "./metrics.ts";

/**
 * A run of text in a box that is as wide as its words rounded up to a whole logical pixel, for a label in a row
 * of boxes (the Moderation window's legend of marks) whose neighbours would otherwise start half a logical pixel
 * off the grid after a word of a width that is not whole. It is measured when it first has its words, when they
 * change and once the pixel font has loaded.
 *
 * @param props The words.
 * @returns The span.
 * @example
 * <WholeText>In combat</WholeText>
 */
export function WholeText({ children }: { readonly children: string }): ReactElement {
  const box = useRef<HTMLSpanElement>(null);
  const width = useWholeWidth(box, children);
  return (
    <span ref={box} style={{ flex: "none", width: width === null ? undefined : logical(width) }}>
      {children}
    </span>
  );
}
